import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { RecordingStates } from './recording-states';

export abstract class RecordingService {
  args: any;
  streamReadySubject = new Subject();
  streamStateSubject = new BehaviorSubject<RecordingStates>(RecordingStates.STOPED);
  isRecording = false;

  constructor(args: any) {
    this.args = args;
  }

  abstract preInit();

  abstract init();

  abstract start(microphoneId: string): Promise<void>;

  abstract play();

  abstract pause();

  abstract stop();

  abstract getInputDevices();

  public onReady() {
    return this.streamReadySubject.asObservable();
  }

  public onStateChanged(): Observable<RecordingStates> {
    return this.streamStateSubject.asObservable();
  }
}
